import React from 'react';
import cx from 'classnames';

import classes from './Card.module.scss';

interface IProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  className?: string;
  background: string;
  iconColor: string;
  size?: string;
}

const Support: React.FC<IProps> = ({ title,description, icon, background,iconColor,className, size}) => {
  return (
    <div
      className={cx(classes.wrapperSupport, className, classes[`wrapper--size-${size}`])}
    >
      <div className={classes.icon} style={{background: background, color:iconColor}}>
        {icon}
      </div>
      <div className={classes.content}>
        <div className={classes.titleSupport}>{title}</div>
        <div className={classes.descriptionSupport}>{description}</div>
      </div>
    </div>
  );
};

export default Support;
